import { gql } from "graphql-request";

const COMPANIES_QUERY = gql`
  query Companies {
    companies(sort: "Slug:asc") {
      Name
      Slug
      id
    }
  }
`;

export default COMPANIES_QUERY;
